<ng-select [(ngModel)]="valueFilter" class="custom" name="TypeObservation" [multiple]="false" (change)="sendFilter()" placeholder="{{'Select' | translate}}">
    <ng-option *ngFor="let data of arrayList" value="{{data}}">{{data}}</ng-option>
</ng-select>